/**
 * TEMPORARY — remove in a few days, along with its use in AnalyticsViewContent.
 *
 * One-organization announcement above the analytics table. The audience check
 * is client-side and decides only what to render; whatever the link points at
 * must authorize its own requests.
 */
import { useProfile } from "@/hooks/useProfile";

const ORG_ID = "7249fa16-d46e-4beb-8bb0-b5c9e7aacf40"; // High Jump Chicago
const URL = "https://hj-post-assessment.vercel.app/"; // paste the link here

const BANNER_CLASS =
  "w-full mb-4 rounded-[20px] bg-gradient-to-r from-[#1C9C6D] to-[#0C714E] px-6 py-5 shadow-[0_4px_20px_rgba(28,156,109,0.25)] flex items-center gap-4";

const OrgAnnouncementBanner = () => {
  const { profile } = useProfile(true);

  if (profile?.organization_id !== ORG_ID) return null;

  const content = (
    <>
      <span aria-hidden="true" className="text-2xl">
        🎉
      </span>
      <span className="font-mulish font-bold text-white text-[18px] flex-1">
        High Jump assessments analytics
      </span>
      {URL && (
        <span
          aria-hidden="true"
          className="shrink-0 font-mulish font-bold text-[15px] text-white/90"
        >
          Open ↗
        </span>
      )}
    </>
  );

  // Without a link there is nothing to click, so it stays a plain block —
  // an anchor with an empty href would navigate to the current page.
  if (!URL) return <div className={BANNER_CLASS}>{content}</div>;

  return (
    <a
      href={URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${BANNER_CLASS} cursor-pointer transition-[filter] hover:brightness-110`}
    >
      {content}
    </a>
  );
};

export default OrgAnnouncementBanner;
